import { useCallback, useRef } from 'react';

/**
 * Returns a debounced version of `fn` that fires after `ms` milliseconds
 * of inactivity. Stable reference — safe to use in dependency arrays.
 */
export function useDebouncedCallback(fn, ms) {
    const t = useRef(null);
    return useCallback(
        (...args) => {
            if (t.current) clearTimeout(t.current);
            t.current = setTimeout(() => fn(...args), ms);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [fn, ms],
    );
}
